import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  importPasses(
    apiKey,
    eventBucket,
    passBucket,
    extraMessage,
    csvFile,
    noEmail,
    preview,
    isMembership
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `bulk_import/passes`,
          json: {
            event_bucket: eventBucket,
            pass_bucket: passBucket,
            extra_message: extraMessage,
            no_email: noEmail,
            preview: preview,
            is_membership: isMembership,
          },
          fileField: "csv",
          file: csvFile,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );

      // Still send a message if the import times out.
      if (!preview) {
        setTimeout(() => {
          resolve({
            success: true,
            message: `Your import has been processed, and emails are being sent. Check the Orders list in the next minute or two to see imported ${isMembership ? "memberships" : "passes"}.`
          });
        }, 15 * 1000);
      }
    });
  },

  fetchPassErrorsCsv(apiKey, errors, passBucketId) {
    return new Promise((resolve, reject) => api.request(
      {
        method: "POST",
        endpoint: `bulk_import/passes/errors`,
        json: {
          errorData: errors,
          passBucket: passBucketId
        },
        api_key: apiKey,
        getText: true
      },
      function (err, response) {
        if (err) {
          return reject(err);
        }
        resolve(response);
      }
    ))
  },

  importEvents(apiKey, eventBucket, csvFile, preview, virtual) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `bulk_import/events`,
          json: {
            event_bucket: eventBucket,
            preview: preview,
            virtual
          },
          fileField: "csv",
          file: csvFile,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  importFilms(apiKey, eventBucket, csvFile, preview) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `bulk_import/films`,
          json: {
            event_bucket: eventBucket,
            preview: preview
          },
          fileField: "csv",
          file: csvFile,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  importPeople(
    apiKey,
    eventBucket,
    subjectLine,
    introMessage,
    extraMessage,
    csvFile,
    preview,
    skipExisting
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `bulk_import/people`,
          json: {
            event_bucket: eventBucket,
            subject_line: subjectLine,
            intro_message: introMessage,
            extra_message: extraMessage,
            skip_existing: skipExisting,
            preview: preview
          },
          fileField: "csv",
          file: csvFile,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/BulkImportUtil.js